import React from "react";
import { Link } from "react-router-dom";
import { Heart, Infinity as InfinityIcon, MessageCircle, Users } from "lucide-react";

/**
 * Four quick-stat tiles at the top of the member dashboard.
 *
 * Extracted verbatim from src/pages/Dashboard.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged.
 */
export default function DashboardStats({ user, connections, convos, favorites }) {
  const stats = [
    {
      label: "Sponsor connections",
      value: connections.length,
      icon: Users,
      to: "#connections",
    },
    {
      label: "Unread messages",
      value: convos.total_unread,
      icon: MessageCircle,
      to: "/messages",
    },
    { label: "Favorites", value: favorites.length, icon: Heart, to: "/favorites" },
    {
      label: user.has_unlimited ? "Messaging" : "Free messages left",
      value: user.has_unlimited
        ? "Unlimited"
        : `${user.free_messages_remaining}/${user.free_message_allowance}`,
      icon: user.has_unlimited ? InfinityIcon : MessageCircle,
      to: "/pricing",
    },
  ];

  return (
    <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((s) => (
        <Link
          key={s.label}
          to={s.to}
          data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
          className="sm-card sm-card-hover p-5 bg-white"
        >
          <s.icon className="w-5 h-5 text-[#1F6F78]" />
          <p className="mt-2 font-display text-2xl font-bold text-[#1F2A2E]">{s.value}</p>
          <p className="text-sm text-[#4B5A60]">{s.label}</p>
        </Link>
      ))}
    </div>
  );
}
